import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    imgBboxRuns: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    crowdGroupId: null,
    imgBboxRunId: null,
    imgBboxDatasets: [],
    imgBboxDsCount: 0,
    imgBboxDsPage: 1,
    imgBboxDsPageSize: 5,
    imgBboxDsPages: 0,
    imgBboxDsSortField: 'task_seq',
    imgBboxDsSortOrder: 'asc',
    imgBboxDsSearch: null,
    imgBboxDsError: '',
    imgBboxResultUrl: ''
}

const receivedImgBboxData=(state, action)=>{
    const { imgBboxRuns,count,page,pageSize,pages,sortField,sortOrder,search,crowdGroupId } = action.data;
    return {
        ...state,
        imgBboxRuns: imgBboxRuns,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        crowdGroupId: crowdGroupId
    }
}

const getImgBboxDataError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedImgBboxDatasets=(state, action)=>{
    const { imgBboxDatasets,imgBboxRunId,count,page,pageSize,pages,sortField,sortOrder,search,imgBboxResultUrl } = action.data;
    return {
        ...state,
        imgBboxRunId: imgBboxRunId,
        imgBboxDatasets: imgBboxDatasets,
        imgBboxDsCount: count,
        imgBboxDsPage: page,
        imgBboxDsPageSize: pageSize,
        imgBboxDsPages: pages,
        imgBboxDsSortField: sortField,
        imgBboxDsSortOrder: sortOrder,
        imgBboxDsSearch: search,
        imgBboxResultUrl: imgBboxResultUrl
    }
}

const getImgBboxDatasetsDataError=(state, action)=> {
    return {
        ...state,
        imgBboxDsError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_IMG_BBOX_RUN_DATA]: receivedImgBboxData,
    [actionTypes.GET_IMG_BBOX_RUN_DATA_ERROR]: getImgBboxDataError,
    [actionTypes.GET_IMG_BBOX_DATASET_DATA]: receivedImgBboxDatasets,
    [actionTypes.GET_IMG_BBOX_DATASET_DATA_ERROR]: getImgBboxDatasetsDataError
});


// WEBPACK FOOTER //
// ./src/redux/imgbbox/reducer.js